import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import autodeskLogo from '../../public/autodesk-logo.svg';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, } from '@mui/material';
import { Typography, Box, Divider, Container } from '@weave-mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderIcon from '@mui/icons-material/Folder';
import HistoryIcon from '@mui/icons-material/History';
import ListAltIcon from '@mui/icons-material/ListAlt';
import WorkIcon from '@mui/icons-material/Work';
import SettingsIcon from '@mui/icons-material/Settings';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import UserMenu from './UserMenu';
import IdeaMenu from './IdeaMenu';
import { useAuth } from '../hooks/useAuth';
import { usePermissions, Actions } from '../hooks/usePermissions';
const DRAWER_WIDTH = 240;
const navigationItems = [
    {
        label: 'Dashboard',
        path: '/dashboard',
        icon: _jsx(DashboardIcon, {}),
        requiredAction: Actions.READ,
    },
    {
        label: 'Batches',
        path: '/batches',
        icon: _jsx(FolderIcon, {}),
        requiredAction: Actions.READ,
    },
    {
        label: 'Hubs',
        path: '/collections',
        icon: _jsx(ListAltIcon, {}),
        requiredAction: Actions.READ,
    },
    {
        label: 'Jobs',
        path: '/jobs',
        icon: _jsx(WorkIcon, {}),
        requiredAction: Actions.READ,
    },
    {
        label: 'Change History',
        path: '/change-history',
        icon: _jsx(HistoryIcon, {}),
        requiredAction: Actions.READ,
    },
    {
        label: 'Data Fix',
        path: '/data-fix',
        icon: _jsx(MedicalInformationIcon, {}),
        requiredAction: Actions.READ,
    },
    {
        label: 'Settings',
        path: '/settings',
        icon: _jsx(SettingsIcon, {}),
        requiredAction: Actions.READ,
    },
];
const Layout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const { hasAction } = usePermissions();
    const handleNavigation = (path) => {
        void navigate(path);
    };
    const visibleNavItems = navigationItems.filter((item) => item.requiredAction ? hasAction(item.requiredAction) : true);
    return (_jsxs(Box, { sx: { display: 'flex', minHeight: '100vh' }, children: [_jsx(AppBar, { position: "fixed", sx: { zIndex: (t) => t.zIndex.drawer + 1, displayPrint: 'none' }, children: _jsxs(Toolbar, { children: [_jsx(Box, { component: "img", src: autodeskLogo, alt: "Autodesk", sx: {
                                height: 24,
                                width: 24,
                                mr: 1.5,
                                cursor: 'pointer',
                                filter: 'brightness(0)',
                            }, onClick: () => handleNavigation('/dashboard') }), _jsx(Typography, { variant: "h6", noWrap: true, component: "div", onClick: () => handleNavigation('/dashboard'), sx: { flexGrow: 1, fontWeight: 600, cursor: 'pointer' }, children: "MFGDM DB Migration Admin" }), user && (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(IdeaMenu, {}), _jsx(UserMenu, {})] }))] }) }), _jsxs(Drawer, { variant: "permanent", sx: {
                    width: DRAWER_WIDTH,
                    flexShrink: 0,
                    displayPrint: 'none',
                    '& .MuiDrawer-paper': {
                        width: DRAWER_WIDTH,
                        boxSizing: 'border-box',
                    },
                }, children: [_jsx(Toolbar, {}), _jsx(Divider, {}), _jsx(List, { sx: { pt: 1 }, children: visibleNavItems.map((item) => (_jsx(ListItem, { disablePadding: true, sx: { mb: 0.5 }, children: _jsxs(ListItemButton, { selected: location.pathname === item.path || location.pathname.startsWith(item.path + '/'), onClick: () => handleNavigation(item.path), children: [_jsx(ListItemIcon, { sx: { minWidth: 40 }, children: item.icon }), _jsx(ListItemText, { primary: item.label, primaryTypographyProps: { fontSize: '0.9rem', fontWeight: 500 } })] }) }, item.path))) })] }), _jsxs(Box, { component: "main", sx: {
                    flexGrow: 1,
                    minWidth: 0,
                    overflow: 'hidden',
                    bgcolor: 'background.default',
                    p: 3,
                    minHeight: '100vh',
                    pb: '48px',
                }, children: [_jsx(Toolbar, { sx: { displayPrint: 'none' } }), _jsx(Container, { maxWidth: "xl", children: _jsx(Outlet, {}) })] }), _jsx(Box, { component: "footer", sx: {
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'background.paper',
                    borderTop: 1,
                    borderColor: 'divider',
                    zIndex: (t) => t.zIndex.drawer,
                    displayPrint: 'none',
                }, children: _jsx(Typography, { variant: "caption", color: "text.secondary", children: "\u00A9 Copyright 2026 Autodesk, Inc. All rights reserved." }) })] }));
};
export default Layout;
